import { useNavigate } from 'react-router-dom';

export type BackButtonProps = {
  scenarioUuid: string;
};

export function BackButton(props: BackButtonProps) {
  const navigate = useNavigate();
  return (
    <button
      onClick={() => navigate(`/scenarios/${props.scenarioUuid}`)}
      className="absolute top-4 left-4 z-50 flex items-center space-x-2 text-white border border-slate-700 rounded-full p-2 bg-slate-700 hover:bg-slate-600 transition-colors duration-300 opacity-50 hover:opacity-100"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="h-6 w-6"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        strokeWidth="2"
      >
        <path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7" />
      </svg>
    </button>
  );
}
